export default "__VITE_ASSET__e29b92f0__"